/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryOrgList(data) {
            return http.json({
                url: 'sys/org/query',
                data
            })

        },

        queryOrgTree(data){
            return http.json({
                url: 'sys/org/query',
                data
            })
        },

        queryPosition(data){
            return http.json({
                url: 'sys/org/queryPosition',
                data
            })
        },
        queryOrgTreeList (data){
            return http.json({
                url: '/sys/org/query',
                data:{"type":"org"}
            });
        },
        queryTenantTreeList (data){
            return http.json({
                url: '/sys/org/query',
                data:{"type":"tenant"}
            });
        },
        queryOrgOnly(data){
            return http.json({
                url: 'sys/org/queryOrg',
                data
            })
        },

        toggleState(data) {
            return http({
                url: `/sys/org/toggleState?id=${data.id}&state=${data.state}`,
                method: 'post'
            })
        },

        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http({
                url: `sys/org/get?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: 'sys/org/save',
                data
            })
        },

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: 'sys/org/delete',
                data
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/api/organization.js